import { getDealListWrapper } from './store/DealsWrapper';
import store from '@/store/store';
export function loadAllDeals() {
  getDealListWrapper('purchase');
  getDealListWrapper('sale');
  getDealListWrapper('transport');
}

function checkIfNotLoaded(refName) {
  const status = store.getState().getIn(['storeStatus', refName]);
  if (!status || status.status != 'loaded') {
    return true;
  }
  return false;
}

export function areAllTheDealsLoaded() {
  let atleastOneIsMissing = false;
  if (checkIfNotLoaded('purchase')) {
    atleastOneIsMissing = true;
  }
  if (checkIfNotLoaded('sale')) {
    atleastOneIsMissing = true;
  }
  if (checkIfNotLoaded('transport')) {
    atleastOneIsMissing = true;
  }
  return !atleastOneIsMissing;
}
